angular.module('psModule').controller('FbeskedCtrl', function ($rootScope, $scope, $q, $timeout, $translate, $filter, $location, $document, $uibModal, benefitService, StorageService, Message, DateService, CapitexSimulationService, TokenService, CustomerDomainService) {
    const loggedInUser = TokenService.getLoggedInUser();
    $scope.userId = loggedInUser.userId;
    $scope.userName = loggedInUser.userName;
    $scope.individualId = $scope.$root.config.individualId;
    $scope.dataLoaded = false;
    $scope.fbesked = {};
    $scope.salaryOptions = [];
    $scope.lastSelectedAnnualSalary = null;
    $scope.salaryModel = {selectedValue: null};
    $scope.optionId = StorageService.getOptionId();
    $scope.capitexRequest = undefined;
    $scope.performingCapitexOperation = false;
    $scope.capitexSimulations = CapitexSimulationService.getSavedSimulations();
    $scope.capitexLoading = false;
    $scope.useCapitexBenefitStatementV2 = $scope.$root.config && $scope.$root.config.toggles && $scope.$root.config.toggles.USE_CAPITEX_BENEFIT_STATEMENT_V2 === true;
    $scope.setCapitexLoading = (loading) => {
        $scope.capitexLoading = loading.detail;
        console.log("Capitex loading:", $scope.capitexLoading);
    };
    $scope.saveSimulations = (simulationsCustomEvent) => {
        const simulationsPayload = simulationsCustomEvent.detail;
        $scope.performingCapitexOperation = true;
        let savePromise;
        if ($scope.capitexSimulations.id) {
            savePromise = CapitexSimulationService.updateSimulations({simulationId: $scope.capitexSimulations.id}, {simulations: simulationsPayload}).$promise;
        } else {
            savePromise = CapitexSimulationService.createSimulations({simulations: simulationsPayload}).$promise;
        }

        savePromise
            .then((r) => {
                $scope.capitexSimulations = CapitexSimulationService.getSavedSimulations();
            })
            .finally(() => $scope.performingCapitexOperation = false);
    };

    /**
     * Fetches all necessary data for the view from the backend.
     *
     * This is the main data-loading function for the controller. It fetches the `fbesked` object,
     * processes it, and populates the scope. It also handles the logic for showing a full-page
     * loader on the initial load versus performing a silent background refresh.
     *
     * @param {boolean} showLoadingScreen - If true, a full-page loader is shown. If false, the data is refreshed in the background.
     * @returns {Promise} A promise that resolves when all data, including translations, has been fetched and processed.
     */
    function fetchAndSetCalcParam(showLoadingScreen = false) {
        if (showLoadingScreen) {
            $scope.dataLoaded = false;
        }

        return benefitService.getFbesked().then(function (fbesked) {
                $scope.fbesked = fbesked;
                $scope.civilstand = fbesked.assumptions.civilstand;
                $scope.inRelationship = $scope.civilstand === 'Gift' || $scope.civilstand === 'Partner';
                $scope.hasChildren = !_.isEmpty(fbesked.assumptions.barn);
                if ($scope.hasChildren) {
                    childrenText(fbesked.assumptions).then(function (text) {
                        $scope.childrenText = text;
                    });
                }

                const employmentSalaryData = fbesked.assumptions.dateradArslon;
                const selfReportedSalaryData = fbesked.assumptions.selfReportedAnnualSalary;

                return finalizeSalarySelection(employmentSalaryData, selfReportedSalaryData);
            }).then(function () {
                $scope.dataLoaded = true;
            }, function () {
                Message.error('ps_missingCustomerInfoMessage_title', 'ps_missingCustomerInfoMessage_text', 'fbeskedFetchErr');
                return $q.reject('Failed to fetch fbesked data.');
            }
        );
    }

    // Initial data fetch. Pass `true` to show the full-page loading screen.
    fetchAndSetCalcParam(true);

    function finalizeSalarySelection(employmentSalaryData, selfReportedSalaryData) {
        const translationKeys = [
            'ps_salary_label_missing',
            'ps_salary_label_add',
            'ps_salary_label_delete',
            'ps_salary_label_employment_suffix',
            'ps_salary_label_manual_suffix'
        ];

        return $translate(translationKeys).then(function (translations) {
            $scope.salaryOptions = [];

            const hasEmploymentSalary = employmentSalaryData && employmentSalaryData.value > 0;
            const hasSelfReportedSalary = selfReportedSalaryData && selfReportedSalaryData.annualPensionSalaryAmount > 0;

            // 1. Add salary options if they exist
            if (hasEmploymentSalary) {
                const employmentLabel = createSalaryLabel(employmentSalaryData.value, translations.ps_salary_label_employment_suffix, employmentSalaryData.startDate);
                $scope.salaryOptions.push({
                    label: employmentLabel,
                    value: employmentSalaryData.value
                });
            }

            if (hasSelfReportedSalary) {
                const selfReportedLabel = createSalaryLabel(selfReportedSalaryData.annualPensionSalaryAmount, translations.ps_salary_label_manual_suffix, selfReportedSalaryData.startDate);
                $scope.salaryOptions.push({label: selfReportedLabel, value: selfReportedSalaryData.annualPensionSalaryAmount});
            }

            // 2. Add action options (Add/Remove)
            if (hasEmploymentSalary || hasSelfReportedSalary) {
                $scope.salaryOptions.push({label: '──────────', value: 'SEPARATOR', disabled: true});
                if (hasSelfReportedSalary) {
                    $scope.salaryOptions.push({label: translations.ps_salary_label_delete, value: 'DELETE_EXISTING'});
                } else {
                    $scope.salaryOptions.push({label: translations.ps_salary_label_add, value: 'ADD_NEW'});
                }
            } else {
                // No salaries exist at all, initial case for customers without employment
                $scope.salaryOptions.push({label: translations.ps_salary_label_missing, value: null, disabled: true});
                $scope.salaryOptions.push({label: translations.ps_salary_label_add, value: 'ADD_NEW'});
                Message.error('ps_missingCustomerInfoMessage_title', 'ps_missingCustomerInfoMessage_text_no_salary', 'noSalaryErr');
            }

            // 3. Set priority order for salary, employment salary should always have precedence
            let initialSalary = null;
            if (hasEmploymentSalary) {
                initialSalary = employmentSalaryData.value;
            } else if (hasSelfReportedSalary) {
                initialSalary = selfReportedSalaryData.annualPensionSalaryAmount;
            }

            $scope.salaryModel.selectedValue = initialSalary;
            updatePrognosWithSalary(initialSalary);
        });
    }

    function createSalaryLabel(annualAmount, labelSuffix, startDate) {
        if (!annualAmount) {
            return '';
        }
        let label = $filter('number')(annualAmount / 12, 0) + ' ' + labelSuffix;
        if (startDate) {
            label += ' (' + startDate + ')';
        }
        return label;
    }

    function updatePrognosWithSalary(newAnnualSalary) {
        $scope.lastSelectedAnnualSalary = newAnnualSalary;

        if ($scope.lastSelectedAnnualSalary === null) {
            $scope.capitexRequest = undefined;
            return;
        }

        if (newAnnualSalary != null) {
            // Integration with Capitex Benefit Service
            // ========================================
            // The fbesked view integrates with the Capitex Benefit Service using the custom elements provided by it.
            // The custom elements are included by including the main.js file published by Capitex Benefit Service.
            // The main.js file is lazy loaded in the router state configuration (see setup of fbesked state at
            // PSFrontend/src/main/angularjs/app.js:50).
            $scope.performingCapitexOperation = true;
            benefitService.getBenefitSummaryRequestWrapper(newAnnualSalary)
                .then(request => {
                    console.log("onSalaryChange: Capitex Benefit Service request: ", request);
                    $scope.capitexRequest = request;
                })
                .finally(() => {
                    $scope.performingCapitexOperation = false;
                });
        }
    }

    /**
     * Handles the user's selection from the salary dropdown menu.
     *
     * This function acts as a router based on the `selectedValue`:
     * - If 'ADD_NEW', it opens the modal to add a new manual salary.
     * - If 'DELETE_EXISTING', it initiates the process to delete the existing manual salary.
     * - If a numeric salary value is selected, it updates the prognosis with the new salary.
     *
     * @param {string|number} selectedValue The value of the chosen option.
     */
    $scope.handleSalarySelection = function (selectedValue) {
        if (selectedValue === 'ADD_NEW') {
            $document[0].getElementById('salary-select').blur();
            openAddSalaryModal();
        } else if (selectedValue === 'DELETE_EXISTING') {
            const salaryToDelete = $scope.fbesked.assumptions.selfReportedAnnualSalary;

            // Safety check: Do not proceed if the salary data or its ID is missing.
            if (!salaryToDelete || !salaryToDelete.id) {
                Message.error('ps_salary_delete_missing_title', 'ps_salary_delete_missing_error', 'deleteSalaryMissingErr');
                $scope.salaryModel.selectedValue = $scope.lastSelectedAnnualSalary;
                return;
            }

            CustomerDomainService.deleteSelfReportedSalary(salaryToDelete.id)
                .then(function() {
                    // Invalidate the frontend cache before fetching new data
                    benefitService.clearFbeskedCache();
                    return fetchAndSetCalcParam(false);
                })
                .then(function() {
                    Message.success('ps_salary_delete_success');
                }).catch(function(error) {
                Message.error('ps_salary_delete_error', error.data && error.data.support_id ? 'Support-ID: '+error.data.support_id:'ps_technical_error', 'deleteSalaryErr');
                console.error("Error during salary deletion or refetch:", error);
                $scope.salaryModel.selectedValue = $scope.lastSelectedAnnualSalary;
            });
            $scope.salaryModel.selectedValue = $scope.lastSelectedAnnualSalary;

        } else if (typeof selectedValue === 'number') {
            updatePrognosWithSalary(selectedValue);
        }
    };

    /**
     * Opens a modal dialog for the user to add a new manual salary.
     *
     * This function handles the entire flow:
     * 1. Opens the 'AddSalaryModalCtrl' modal.
     * 2. On successful save, it receives the new annual salary from the modal.
     * 3. It then calls the CustomerDomainService to save the new salary to the backend.
     * 4. After a successful save, it invalidates the local cache and refetches all data to update the view.
     * 5. If the user cancels or an error occurs, it resets the salary dropdown to its previous state.
     *
     * The modal opening is wrapped in a `$timeout` to prevent UI focus issues with the
     * underlying `<select>` element.
     */
    function openAddSalaryModal() {
        $timeout(function() {
            var modalInstance = $uibModal.open({
                template:'<div class="modal-header"><h3 class="modal-title" translate="ps_addSalaryModal_title"></h3></div><div class="modal-body"><form name="addSalaryForm" novalidate><div class="form-group"><label for="monthly-salary" translate="ps_addSalaryModal_label"></label><div class="input-group"><input type="number" id="monthly-salary" class="form-control" ng-model="salary.monthly" placeholder="{{ \'ps_addSalaryModal_placeholder\' | translate }}" required min="1"><div class="input-group-addon" translate="ps_addSalaryModal_currency_sek"></div></div></div></form></div><div class="modal-footer"><button class="btn btn-default" type="button" ng-click="cancel()" translate="ps_addSalaryModal_cancel"></button> <button class="btn btn-primary" type="button" ng-click="save()" ng-disabled="addSalaryForm.$invalid" translate="ps_addSalaryModal_save"></button></div>',
                controller: 'AddSalaryModalCtrl',
                size: 'sm'
            });

            modalInstance.result.then(function (newAnnualSalary) {
                const today = new Date();
                const formattedDate = today.toISOString().split('T')[0]; // Format YYYY-MM-DD

                const salaryDto = {
                    annualPensionSalaryAmount: newAnnualSalary,
                    startDate: formattedDate
                };

                CustomerDomainService.saveSelfReportedSalary(salaryDto).then(function () {
                    Message.success('ps_salary_add_success');
                    benefitService.clearFbeskedCache();
                    fetchAndSetCalcParam(false);
                })
                .then(function () {

                })
                .catch(function (error) {
                    Message.error('ps_salary_add_error_title', 'ps_salary_add_error', 'addSalaryErr');
                    console.error("Error saving self-reported salary:", error);
                    $scope.salaryModel.selectedValue = $scope.lastSelectedAnnualSalary;
                });

            }, function () {
                $scope.salaryModel.selectedValue = $scope.lastSelectedAnnualSalary;
            });
        }, 0);
    }

    // Need to refresh data when language changes
    var cleanUpFunc = $rootScope.$on('$translateChangeEnd', function () {
        fetchAndSetCalcParam(true);
    });

    // Need to remove eventlistener when leaving the scope
    $scope.$on('$destroy', function () {
        cleanUpFunc();
    });

    $scope.hasContent = function (fbesked, category, subcat) {
        let categoryMapElement = fbesked.categoryMap[category];
        if (categoryMapElement) {
            let subCategoryMapElement = categoryMapElement.subCategoryMap[subcat];
            if (subCategoryMapElement) {
                let forsakringsbeloppList = subCategoryMapElement.forsakringsbeloppList;
                if (forsakringsbeloppList) {
                    return forsakringsbeloppList.length > 0;
                }
            }
        }
        return false;
    };

    function childrenText(assumptions) {

        var translationKeys = [
            "ps_fbesked_calcparams_barn_years",
            "ps_fbesked_calcparams_unknown_age",
            "ps_fbesked_calcparams_barn_legalStatus-Gemensamt-singularis",
            "ps_fbesked_calcparams_barn_legalStatus-Gemensamt-pluralis",
            "ps_fbesked_calcparams_barn_legalStatus-Sarkull-singularis",
            "ps_fbesked_calcparams_barn_legalStatus-Sarkull-pluralis",
            "ps_fbesked_calcparams_barn_legalStatus-Partners-singularis",
            "ps_fbesked_calcparams_barn_legalStatus-Partners-pluralis"
        ];

        return $translate(translationKeys).then(function (translations) {

            var ageTranslated = translations['ps_fbesked_calcparams_barn_years'];
            var unknownAgeTranslated = translations['ps_fbesked_calcparams_unknown_age'];

            function joinBy(delim) {
                return function (memo, part) {
                    return memo + delim + part;
                };
            }

            function ageTxt(children) {
                var ageDescriptions = _.map(children, function (child) {
                    return !!child.fodelsedatum ? DateService.getAge(child.fodelsedatum) + ' ' + ageTranslated : unknownAgeTranslated;
                });
                return _.chain(ageDescriptions)
                    .reduce(joinBy(', '))
                    .value();
            }

            function legalStatusTxt(children, key) {
                var tsKey = children.length === 1 ? 'ps_fbesked_calcparams_barn_legalStatus-' + key + '-singularis' :
                    'ps_fbesked_calcparams_barn_legalStatus-' + key + '-pluralis';
                return children.length + " " + translations[tsKey] + ' ' + ageTxt(children);
            }

            var byLegalStatus = _.groupBy(assumptions.barn, 'legalStatus');
            var byLegalStatusTxt = _.chain(byLegalStatus)
                .map(legalStatusTxt)
                .reduce(joinBy(', '))
                .value();

            return $translate('ps_fbesked_calcparams_barn', {
                total: assumptions.barn.length,
                byLegalStatus: byLegalStatusTxt
            });
        });
    }
});
